import './styles.scss'
import * as Structures from "../../structures"
import { useRowDesign } from '../../elements/useRowDesign'
import { InlineActionbar } from '../../components/InlineActionbar'
import { useContext, useRef, useState, useMemo } from 'react'
import useClickOutside from '../../hooks/useClickOutside'
import { ContainerLockedContext, DialogModes } from '../../contexts'
import { SortableContext } from "@dnd-kit/sortable"
import { DndSortable } from '../../components/DragAndDrop/sortable'

const defaultBitmapData = {
  type: 4,
  property: 'Logo',
  value: 'data:image/png;base64,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',
  placeholder: 'Metaforce logo',
  layout: {
    order: 5,
  },
  styles: {
    borderWidth: 0
  }
}

export default function Row({ data, dialogData, draggableProvided = null, dndProps = null, ...props }) {
  data = data || defaultBitmapData
  const classPrefix = "row"

  const { isEditMode } = useContext(DialogModes);
  const containerLockedContext = useContext(ContainerLockedContext)
  // const designActionbarContext = useContext(DesignActionbarContext);
  // const { 
  //   selectedLayoutType,
  //   onSetSelectedLayoutType
  // } = designActionbarContext
  const borderWidthStyle = data?.borderWidth ? `${data.borderWidth}` : 'inherit'
  const borderColorStyle = data?.borderColor ? `${data.borderColor}` : 'inherit'
  const backgroundColorStyle = data?.backgroundColor ? data.backgroundColor : 'transparent'
  const marginStyle = data?.margin ? data.margin : 'default'
  const paddingStyle = data?.padding ? data.padding : 'default'
  const roundedCornerClass = data?.roundedCorners ? 'rounded-md' : ''

  const gapClass = data?.gap ? `gap-${data.gap}` : ''

  const totalCols = data.columns.reduce((total, column) => total + (column?.span || 1), 0);

  const style = {
    borderWidth: borderWidthStyle,
    borderColor: borderColorStyle,
    backgroundColor: backgroundColorStyle,
    margin: marginStyle,
    padding: paddingStyle
  }

  const rowDesign = useRowDesign(data.id, data)

  const ref = useRef();
  const [isModalOpen, setModalOpen] = useState(false);
  useClickOutside(ref, () => setModalOpen(false));

  const handleRowClick = () => {
    setModalOpen(rowDesign.isActive)
    //rowDesign.setCurrent();
    rowDesign.onClick();
  }

  const close = () => {
    setModalOpen(false);
  }

  const items = useMemo(() => data.columns || [], [data.columns])

  const getColumn = (column) => {
    return <Structures.Column
      key={`column-${column.id}`}
      data={column}
      dialogData={dialogData}
      style={style}
    />
  }

  return (
    <div
      {...draggableProvided?.draggableProps}
      ref={draggableProvided?.innerRef}
      className={`relative ${dndProps?.isDragging ? 'border-2 border-red-600' : ''}`}
    >
      <div
        ref={ref}
        className={`grid sm:grid-cols-${totalCols} print:grid-cols-${totalCols} ${gapClass} ${roundedCornerClass} ${rowDesign.rowsClasses(data?.backgroundColor)} no-break`}
        style={style}
        onClick={handleRowClick}
      >
        <InlineActionbar close={close} isOpen={isModalOpen && rowDesign.isSelected()} type={'row-actionbar'} onShowPropertiesClick={rowDesign.onClick} />
        {
          isEditMode && items && !containerLockedContext.isLocked ?
            (
              <SortableContext
                id={`row-sortable-context-${data.id}`}
                items={items.map((i) => `column-${i.id}`)}
              >
                {items.map(column => {
                  return (
                    <DndSortable
                      className={`sm:col-span-${column?.span}`}
                      key={column?.id}
                      type="column"
                      id={`column-${column.id}`}
                      dragHandle={true}
                      dragHandleTooltip='Drag column'
                    >
                      {getColumn(column)}
                    </DndSortable>
                  )
                })}
              </SortableContext>
            )
            : data.columns.map((column, i) => getColumn(column))

        }
      </div>
    </div>
  )
}
